import { IAppConfig } from "./iapp-config";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { Injectable, enableProdMode } from "@angular/core";

const jsonFile =  `../../assets/config/env.${environment.name}.json`;

if (environment.production) {
    enableProdMode();
}

@Injectable()
export class Config {
    static info:IAppConfig;
    constructor(private http: HttpClient){ }
    
    load(){
        return new Promise((resolve, reject) => {
            this.http.get<any>(jsonFile)
            .subscribe(
                (data: IAppConfig) =>{
                    Config.info = data;
                    resolve(true);
                },
                err=> reject(err)
            );
        });
    }
}